import { render, staticRenderFns } from "./mtPreve.vue?vue&type=template&id=19cbf75d&"
import script from "./mtPreve.vue?vue&type=script&lang=js&"
export * from "./mtPreve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports